import { TableBody, TableCell, TableRow } from '@windmill/react-ui';
import React, { useState, useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import TripadvanceApproval from 'components/modal/TripadvanceApprovalModel'; // Ensure this is correctly imported
import { notifySuccess } from 'utils/toast';
import ItineraryModal from 'components/form/ItineraryModal';
import TripadvanceApprovalServices from 'services/TripadvanceApprovalServices';
const adminInfo = localStorage.getItem('adminInfo')
	? JSON.parse(localStorage.getItem('adminInfo'))
	: null;
const TripadvanceApprovalTable = ({
	tripadvanceapproval,
	perpage,
	currentPage,
}) => {
	const { setIsUpdate } = useContext(SidebarContext);
	const [showItineraryModal, setShowItineraryModal] = useState(false);
	const [error, setError] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [selectedData, setSelectedData] = useState(null);
	const [billamount, setBillamount] = useState(null);
	const [clientid, setClientid] = useState(null);
	const [currentid, setcurrentid] = useState(null);
	const [, setOpenModal] = useState(false);

	const [itinerary] = useState('');

	const closeModal = () => {
		setShowModal(false);
		setOpenModal(false);
		setSelectedData(null);
		setError('');
	};

	const handleSubmit = async (selectedIds, remainingAmount, remarks) => {
		// Prepare the payload using the required data

		const payload = {
			va_id: selectedIds,
			id_client: clientid,
			va_id_current: currentid,
			adjust_amount: remainingAmount,
			employee_id: adminInfo?.id,
			adjusted_remark: remarks,
		};

		try {
			const response = await TripadvanceApprovalServices.adjustOutstanding(
				payload
			); // Sending the payload to the service
			if (response?.status) {
				notifySuccess(response.message); // Notify success if the response is successful
				setIsUpdate(true);
				closeModal();
			} else {
				setError('Failed to update the Bill Approval.');
			}
		} catch (error) {
			console.error('API Error:', error);
			setError('An error occurred while updating Bill Approval.');
		}
	};
// console.log("came to approval")
	return (
		<>
			<TripadvanceApproval
				isOpen={showModal}
				onClose={closeModal}
				handleSubmit={handleSubmit}
				data={selectedData}
				billAmount={billamount}
				error={error}
			/>
			<ItineraryModal
				isOpen={showItineraryModal}
				content={itinerary}
				onClose={() => setShowItineraryModal(false)}
			/>
			<TableBody>
				{tripadvanceapproval
					.slice((currentPage - 1) * perpage, currentPage * perpage)
					.map((data, index) => (
						<TableRow key={data.id}>
							<TableCell className="text-xs text-center">
								{(currentPage - 1) * perpage + index + 1}
							</TableCell>
							<TableCell className="text-xs text-center">
								{data.ref_no}
								{/* {console.log(data)} */}
							</TableCell>

							<TableCell className="text-xs text-center">
								{data.client_name}
							</TableCell>
							<TableCell>
								<div className="flex flex-col items-center">
									<span className="text-sm">{data.start_date}</span>
									<span className="text-sm">{data.end_date}</span>
								</div>
							</TableCell>
							<TableCell className="text-xs text-center">
								{data.arrival}
							</TableCell>
							<TableCell className="text-xs text-center">
								{data.vendor_name}
							</TableCell>

							<TableCell>
								<div className="text-sm flex flex-col items-center space-y-3">
									<span className="text-sm">{data.trip_advance_request}</span>
								</div>
							</TableCell>
							<TableCell>
								<div className="text-sm flex flex-col items-center space-y-3">
									<span className="text-sm">{data.trip_advance_paid}</span>
								</div>
							</TableCell>
							<TableCell>
								<div className="text-sm flex flex-col items-center space-y-3">
									<span className="text-sm">
										{data.trip_advance_request - data.trip_advance_paid}
									</span>
								</div>
							</TableCell>

							<TableCell>
								<span className="text-sm">{data.paid_status}</span>
							</TableCell>
							<TableCell>
								<span className="text-sm">{data.paid_date}</span>
							</TableCell>
							<TableCell>
								<span className="text-sm">{data.payment_type}</span>
							</TableCell>
							<TableCell>
								<span className="text-sm">{data.paid_remark}</span>
							</TableCell>
							<TableCell>
								<span
									className="text-sm text-center text-green-500 cursor-pointer"
									layout="outline"
									onClick={async () => {
										try {
											const response =
												await TripadvanceApprovalServices.checkoutstanding(
													data.vendor_id
												);

											if (response?.status) {
												setSelectedData(response.data);
												setBillamount(data.trip_advance_request);
												setClientid(data.id_client);
												setcurrentid(data.va_id);

												setShowModal(true);
											} else {
												setError('Failed to fetch Bill Approval .');
											}
										} catch (error) {
											console.error('API Error:', error);
											setError(
												'An error occurred while fetching Bill Approval .'
											);
										}
										// console.log(data.adjust_amount, 'data.adjust_amount');
									}}
								>
									Tripadvance Approval
								</span>
							</TableCell>
						</TableRow>
					))}
			</TableBody>
		</>
	);
};

export default TripadvanceApprovalTable;
